import { render, staticRenderFns } from "./ExerciseList.vue?vue&type=template&id=b0fbffb8&scoped=true&"
import script from "./ExerciseList.vue?vue&type=script&lang=js&"
export * from "./ExerciseList.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseList.vue?vue&type=style&index=0&id=b0fbffb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fbffb8",
  null
  
)

export default component.exports